// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__LL29L","author":"Table_author__2rySY","authorImage":"Table_authorImage__vPA-g","unreadRow":"Table_unreadRow__2o_BQ"};